import React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { useTranslation } from "react-i18next";
import useStyles from "./FmCarouselData.style";
import { TWO, FIVE } from "../../Utils/Consts";

interface FmCarouselDataProps {
    tableData: any;
}

const FmCarouselData = ({ tableData }: FmCarouselDataProps) => {
    const classes = useStyles();
    const theme = useTheme();
    const { t } = useTranslation();
    const [activeStep, setActiveStep] = React.useState(0);

    const dynamicSteps = tableData.map((mon: any, index: number) => {
        return {
            label: mon.name,
            values: [mon.N.toFixed(2), mon.P.toFixed(2), mon.K.toFixed(2)],
        };
    });

    const maxSteps = dynamicSteps.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <Box sx={{ flexGrow: 1, padding: "10px", width: "100%" }}>
            <Paper
                square
                elevation={0}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    height: 60,
                    p: 2,
                }}
            >
                <div className={classes.caroselHeader_container}>
                    <span className={classes.boldText}>{dynamicSteps[activeStep].label}</span>
                    <span>{t("wideTable.caroselHeader.title")}</span>
                </div>
            </Paper>
            <Box sx={{ height: 288, width: "100%", p: 2, background: "#E4F5EC" }}>
                <div className={classes.caroselBody_container}>
                    <div className={classes.bodyRow}>
                        <span className={classes.labelName}>{t("wideTable.sideLabel.label1")}</span>
                        <span>{dynamicSteps[activeStep].values[0]}</span>
                    </div>
                    <div className={classes.bodyRow}>
                        <span className={classes.labelName}>
                            {t("wideTable.sideLabel.label2")}
                            <span className={classes.smallFont}>{TWO}</span>
                            {t("wideTable.sideLabel.label2_1")}
                            <span className={classes.smallFont}>{FIVE}</span>
                        </span>
                        <span>{dynamicSteps[activeStep].values[1]}</span>
                    </div>
                    <div className={classes.bodyRow}>
                        <span className={classes.labelName}>
                            {t("wideTable.sideLabel.label3")}
                            <span className={classes.smallFont}>{TWO}</span>
                            {t("wideTable.sideLabel.label2_1")}
                        </span>
                        <span>{dynamicSteps[activeStep].values[2]}</span>
                    </div>
                </div>
            </Box>
            <MobileStepper
                variant='text'
                steps={maxSteps}
                position='static'
                activeStep={activeStep}
                nextButton={
                    <Button size='small' onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                        {t("wideTable.next")}
                        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                    </Button>
                }
                backButton={
                    <Button size='small' onClick={handleBack} disabled={activeStep === 0}>
                        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                        {t("wideTable.back")}
                    </Button>
                }
            />
        </Box>
    );
};

export default FmCarouselData;
